export default __webpack_public_path__ + "static/media/info-item7.c0f05294.svg";